import { ReplayAccessMethod } from '../../../../shared/entity_datas/EntityDatas.ts';
import { UIAPIEndpoints } from '../network/UIAPIEndpoints.ts';
import { UIAjaxWrapper } from '../network/UIAjaxWrapper.ts';
export const REPLAY_URL_ACTION_SEARCH_PARAM_NAME = 'action';
export async function getReplayInitiationData(href) {
    const replayDataUrl = getReplayDataUrl(href);
    const replayDataResponse = await UIAjaxWrapper.getRequestHandler(replayDataUrl, undefined);
    const replayData = replayDataResponse === null || replayDataResponse === void 0 ? void 0 : replayDataResponse.json.data;
    if (replayData === undefined) throw new Error('Missing replayData');
    return replayData;
}
export function getReplayDataUrl(href) {
    const replayUrlSlug = getReplayUrlSlug(href);
    if (replayUrlSlug !== undefined) return UIAPIEndpoints.apiReplayDataFromSlug(replayUrlSlug);
    const gameId = getReplayUrlGameId(href);
    const playerColor = getReplayUrlPlayerColor(href);
    if (gameId !== undefined && playerColor !== undefined) return UIAPIEndpoints.apiReplayDataFromGameId(gameId, playerColor);
    throw new Error('Missing replayUrlSlug and replayUrlGameId');
}
export function getReplayUrlSlug(href) {
    const replayUrlSlugRegex = /https?:\/\/[^/]+(?:\/[^/]+)*\/replay\/([^/?]+)/;
    const replayUrlSlugMatch = href.match(replayUrlSlugRegex);
    if ((replayUrlSlugMatch === null || replayUrlSlugMatch === void 0 ? void 0 : replayUrlSlugMatch[1]) === undefined) return;
    return replayUrlSlugMatch[1];
}
export function getReplayUrlGameId(href) {
    const pageUrl = new URL(href);
    const gameIdOrNull = pageUrl.searchParams.get('gameId');
    if (gameIdOrNull === null) return undefined;
    return gameIdOrNull;
}
export function getReplayUrlPlayerColor(href) {
    const pageUrl = new URL(href);
    const playerColorOrNull = pageUrl.searchParams.get('playerColor');
    if (playerColorOrNull === null) return undefined;
    return Number(playerColorOrNull);
}
export function getReplayUrlActionIndex(href) {
    const pageUrl = new URL(href);
    const action = pageUrl.searchParams.get(REPLAY_URL_ACTION_SEARCH_PARAM_NAME);
    if (action === null) return -1;
    const actionIndex = Number(action);
    if (!Number.isInteger(actionIndex)) return -1;
    if (actionIndex < 0) return -1;
    return actionIndex;
}
export function getReplayAccessMethod(href) {
    if (getReplayUrlSlug(href) !== undefined) return ReplayAccessMethod.ShareableLink;
    if (getReplayUrlGameId(href) !== undefined) return ReplayAccessMethod.DirectLink;
    return ReplayAccessMethod.EndGame;
}
